export default __webpack_public_path__ + "static/media/ASL.e6d50a27.png";